export const HowItWorksListCircle = ({ index }: { index: number }) => (
  <svg width="40" height="35" viewBox="0 0 40 35" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M2.86369 24.1936C-0.405602 19.588 -1.03808 13.487 1.81255 8.45698C2.58214 7.09885 3.76303 5.9508 4.97167 4.85864C6.42433 3.54507 7.96512 2.26829 9.80542 1.39328C13.9871 -0.595813 21.0578 -0.0957095 25.5374 0.69229C47.8364 4.61743 43.1847 38.4922 19.5692 33.644C15.4292 32.7937 11.6792 30.9072 8.10876 28.9018C5.9616 27.6951 4.19393 26.0681 2.86369 24.1936Z"
      fill="#D67347"
    />
    <text
      x="50%"
      y="50%"
      textAnchor="middle"
      dominantBaseline="middle"
      fontFamily="Zizzi"
      fontSize="24"
      fill="white"
    >
      {index}
    </text>
  </svg>
);
